﻿import TimeSlider from "@arcgis/core/widgets/TimeSlider";
import { buildJsTimeSliderStops } from "./jsBuilder";
import * as Core from "./arcGisJsInterop";
import MapView from "@arcgis/core/views/MapView";
import WebMap from "@arcgis/core/WebMap";
import { buildDotNetTimeExtent } from "./dotNetBuilder";

export default class TimeSliderWidgetWrapper {
    private timeSlider: TimeSlider;

    constructor(timeSlider: TimeSlider) {
        this.timeSlider = timeSlider;
    }

    async setFullTimeExtent(dotNetTimeExtent: any) {
        this.timeSlider.fullTimeExtent = dotNetTimeExtent;
    }

    async setStops(dotNetStops: any) {
        let sliderStops = buildJsTimeSliderStops(dotNetStops);
        this.timeSlider.stops = sliderStops;
    }

    async setLabelFormatFunction(labelFormatFunc: any) {
        let timeSlider = this.timeSlider;

        let labelFormat: Function | null = new Function(labelFormatFunc);

        // ReSharper disable TS2322
        // @ts-ignore
        this.timeSlider.labelFormatFunction = labelFormat;
        // ReSharper restore TS2322
    }

    async setPropertiesFromWebMap(properties: any) {

        this.timeSlider.fullTimeExtent = properties.fullTimeExtent;
        this.timeSlider.loop = properties.loop;
        this.timeSlider.playRate = properties.playRate;
        this.timeSlider.mode = properties.mode;
        this.timeSlider.stops = buildJsTimeSliderStops(properties.stops) ?? undefined;
        this.timeSlider.timeExtent = properties.timeExtent;
    }

    async getPropertiesFromWebMap(viewId: any, signal: any): Promise<any> {
        const view = Core.arcGisObjectRefs[viewId] as MapView;
        const webMap = view.map as WebMap;
        const properties = await TimeSlider.getPropertiesFromWebMap(webMap);
        if (properties == null) {
            return null;
        }

        const result = {
            fullTimeExtent: buildDotNetTimeExtent(properties.fullTimeExtent),
            loop: properties.loop ?? null,
            playRate: properties.playRate ?? null,
            Mode: properties.mode ?? null,
            stops: properties.stops ?? null,
            timeExtent: buildDotNetTimeExtent(properties.timeExtent)
        };

        //we set the type because the .NET side doesn't know how to handle the different stops objects
        if (result.stops != null) {
            if (result.stops.dates != null) {
                result.stops.type = "stops-by-dates";
            } else if (result.stops.count != null) {
                result.stops.type = "stops-by-count";
            } else {
                result.stops.type = "stops-by-interval";
            }
        }
        return result;
    }
}